import { render, staticRenderFns } from "./DocSubtypeForm.vue?vue&type=template&id=2bb27ba3&scoped=true"
import script from "./DocSubtypeForm.vue?vue&type=script&lang=js"
export * from "./DocSubtypeForm.vue?vue&type=script&lang=js"
import style0 from "./DocSubtypeForm.vue?vue&type=style&index=0&id=2bb27ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb27ba3",
  null
  
)

export default component.exports